import { BuildClass, Do, clamp, fsmData, timer } from '../../universal';
import { $, React, _ } from '../lib';
import { J2rLoadingSpinner, j2r, reactRender } from './component-react';
import { J2rListComponent } from './component-react-list';
import { trionlineAjax } from './component-trionline';
import { newSystemFlyout } from './flyouts';
let facilitySwitcherData = null;
export const clearFacilitySwitcherCache = () => {
    facilitySwitcherData = null;
    if (window.rootData?.Switcher) {
        delete window.rootData.Switcher;
    }
};
export const updateFacilityUI = () => {
    switchFacilityNew();
};
export const switchFacilityNew = () => {
    const sess = window.rootData?.Session;
    const auth = sess?.Authority ?? Number($('#var_auth').val() ?? -1);
    const is_sn = sess && (auth >= 8 || sess.RealUser !== sess.User || sess.User < 100000);
    const flyout = newSystemFlyout({
        cl: 'facility-picker-2018-wrapper',
        size: Do(() => {
            if (is_sn) {
                return [720, 500];
            }
            return [360, 500];
        }),
    });
    const flyoutFinished = new Promise(resolve => {
        timer(500, () => {
            resolve();
        });
    });
    if (!flyout.Element) {
        console.error('Facility switcher flyout element unavailable');
        return;
    }
    reactRender(flyout.Element, j2r({
        tag: FacilitySwitcherUI,
        flyout,
        flyoutFinishedPromise: flyoutFinished,
        showServers: is_sn,
    })).then(cmpt => {
        if (!cmpt) {
            console.error('Failed to render facility switcher');
            return;
        }
        if (facilitySwitcherData != null) {
            cmpt.setData(facilitySwitcherData);
            if ('isSN' in facilitySwitcherData && facilitySwitcherData['isSN']) {
                flyout.ChangeSize({ width: 720, height: 500 });
            }
            return;
        }
        if (window.rootData?.Switcher != null) {
            cmpt.setData(window.rootData.Switcher);
            return;
        }
        trionlineAjax({
            url: '/api/switch/',
            yes: data => {
                if (data == null) {
                    return;
                }
                facilitySwitcherData = JSON.parse(data);
                if (facilitySwitcherData != null) {
                    cmpt.setData(facilitySwitcherData);
                    if ('isSN' in facilitySwitcherData && facilitySwitcherData['isSN']) {
                        flyout.ChangeSize({ width: 720, height: 500 });
                    }
                }
            },
        });
    });
};
class FacilitySwitcherUI extends React.Component {
    list;
    constructor(props) {
        super(props);
        this.list = React.createRef();
        const auth = window.rootData?.Session?.Authority ?? $('#var_auth').val();
        const is_sn = +auth >= 8;
        this.state = {
            init: false,
            facilities: null,
            rosters: null,
            servers: null,
            highlightedFacility: null,
            selectedFacility: null,
            highlightedSubroster: null,
            selectedSubroster: null,
            search: '',
            sortKey: 0,
            sortReverse: false,
            isSN: is_sn,
            showServers: this.props.showServers ?? false,
            currentServer: Do(() => {
                const subdomain = location.host.replace(/trionline\.com\.au/g, '');
                return subdomain.replace(/\./g, '');
            }),
        };
    }
    setData(data) {
        if (data['isSN']) {
            this.props.flyoutFinishedPromise.then(() => {
                this.setState({ showServers: true });
            });
        }
        this.setState({
            init: true,
            servers: data['servers'],
            facilities: Array.isArray(data['facilities'])
                ? data['facilities'].map((F) => ({
                    ID: F[0],
                    Name: F[1],
                    Enabled: F[2],
                }))
                : null,
            rosters: Array.isArray(data['rosters'])
                ? data['rosters'].map((F) => ({
                    Facility: F[0],
                    SubRoster: F[1],
                    Name: F[2],
                }))
                : null,
            highlightedFacility: Array.isArray(data['current'])
                ? data['current'][0]
                : null,
            highlightedSubroster: Array.isArray(data['current'])
                ? data['current'][1]
                : null,
        }, () => {
            if (this.getFacilities().length === 1) {
                this.selectFacility();
                return;
            }
            const index = Do(() => {
                let highlightedIndex = null;
                _.forEach(this.getFacilities(), (F, i) => {
                    if (this.state.highlightedFacility === F.ID) {
                        highlightedIndex = i;
                        return false;
                    }
                    return undefined;
                });
                return highlightedIndex;
            });
            if (index != null) {
                let pixels = index * this.rowHeight();
                pixels = clamp(pixels - 140, 0, 10e9);
                if (this.list.current?.listElement.current) {
                    this.list.current.listElement.current.scrollTop = pixels;
                }
            }
        });
    }
    render() {
        return j2r(() => {
            if (!this.state.init) {
                return {
                    tag: J2rLoadingSpinner,
                    size: 'small',
                };
            }
            else if (this.state.selectedSubroster != null) {
                return {
                    cl: 'cntr',
                    style: { marginTop: '120px' },
                    children: [
                        {
                            key: 'text',
                            cl: 'error_msg_2',
                            text: 'Switching...',
                        },
                        {
                            tag: J2rLoadingSpinner,
                            key: 'loading',
                            size: 'small',
                        },
                    ],
                };
            }
            return {
                cl: 'wrapper',
                key: 'wrapper',
                children: [
                    {
                        key: 'flyout-heading',
                        cl: 'flyout-heading',
                        text: 'Switch Facility',
                    },
                    this.buildFacilityPickerCombo(),
                ],
            };
        });
    }
    buildFacilityPickerCombo() {
        return {
            cl: 'facility-picker-combo',
            key: 'facility-picker-combo',
            children: [
                this.buildFacilityPicker(),
                this.state.showServers ? this.buildServerPicker() : undefined,
            ],
        };
    }
    buildServerPicker() {
        return {
            key: 'server-picker',
            cl: 'server-picker',
            children: Do(() => {
                const items = [
                    {
                        key: 'heading-servers',
                        cl: 'heading',
                        text: 'Servers',
                        children: [],
                    },
                ];
                const headings = {
                    1: 'Prod',
                    2: 'Beta',
                    3: 'Dev',
                };
                const server_groups = _.groupBy(this.state.servers, x => {
                    if (x.IsProd) {
                        return 1;
                    }
                    else if (x.IsDev) {
                        return 3;
                    }
                    return 2;
                });
                _.map(server_groups, (servers, k) => {
                    if (servers.length === 0) {
                        return;
                    }
                    const groupKey = parseInt(k, 10);
                    items.push({
                        cl: 'subheading',
                        key: `subheading-${k}`,
                        text: headings[groupKey],
                        children: [],
                    });
                    _.sortBy(servers, x => x.ID).forEach(x => {
                        items.push({
                            key: `server-${x.Subdomain}`,
                            cl: BuildClass({
                                server: true,
                                selected: this.state.currentServer === x.Subdomain,
                            }),
                            children: [
                                {
                                    tag: 'span',
                                    cl: 'fullname',
                                    key: 'fullname',
                                    text: x.FullName,
                                    title: x.FullName,
                                },
                                {
                                    tag: 'span',
                                    cl: 'subdomain',
                                    key: 'subdomain',
                                    text: x.Subdomain,
                                    title: x.Subdomain,
                                },
                                {
                                    tag: 'span',
                                    cl: 'desc',
                                    key: 'desc',
                                    text: x.Description,
                                    title: x.Description,
                                },
                            ],
                            onClick: () => {
                                if (this.state.currentServer === x.Subdomain) {
                                    return;
                                }
                                const curr_host = Do(() => {
                                    if (this.state.currentServer === '') {
                                        return 'https://trionline.com.au';
                                    }
                                    return `https://${this.state.currentServer}.trionline.com.au`;
                                });
                                const new_host = Do(() => {
                                    if (x.Subdomain) {
                                        return `https://${x.Subdomain}.trionline.com.au`;
                                    }
                                    return 'https://trionline.com.au';
                                });
                                location.href = location.href.replace(curr_host, new_host);
                            },
                        });
                    });
                });
                return items;
            }),
        };
    }
    buildFacilityPicker() {
        return {
            cl: 'facility-picker-2018',
            key: 'facility-picker-2018',
            children: [
                this.buildSearchBox(),
                this.state.selectedFacility != null
                    ? this.renderSubrosters()
                    : this.renderFacilities(),
            ],
        };
    }
    rowHeight() {
        if (window.size === 'mobile') {
            return 39;
        }
        return 29;
    }
    renderFacilities() {
        return {
            tag: J2rListComponent,
            ref: this.list,
            value: this.state.highlightedFacility,
            key: 'render-facilities',
            onUpdate: (v) => {
                this.setState({ highlightedFacility: v });
            },
            lazyRenderHeight: this.rowHeight(),
            headingRow: {
                cl: 'gridRow noselect heading',
                children: ['ID', 'Name'].map((txt, index) => ({
                    tag: 'span',
                    key: txt,
                    text: txt,
                    title: `${txt} column. Click to sort.`,
                    onClick: () => {
                        this.changeSort(index + 1);
                    },
                })),
            },
            items: this.getFacilities().map(F => ({
                cl: BuildClass({
                    facility: true,
                    gridRow: true,
                    disabled: F.Enabled === 0,
                }),
                value: F.ID,
                onClick: () => {
                    this.selectFacility(F.ID);
                },
                children: [String(F.ID), F.Name].map(txt => ({
                    tag: 'span',
                    key: txt,
                    title: txt,
                    text: txt,
                })),
            })),
        };
    }
    renderSubrosters() {
        return {
            tag: J2rListComponent,
            value: this.state.highlightedSubroster,
            key: 'render-subrosters',
            onUpdate: (v) => {
                this.setState({ highlightedSubroster: v });
            },
            lazyRenderHeight: this.rowHeight(),
            headingRow: {
                cl: 'gridRow noselect heading',
                children: ['ID', 'Name'].map((txt, index) => ({
                    tag: 'span',
                    key: txt,
                    text: txt,
                    title: `${txt} column. Click to sort.`,
                    onClick: () => {
                        this.changeSort(index + 1);
                    },
                })),
            },
            items: this.getSubrosters().map(R => ({
                cl: 'facility gridRow',
                value: R.SubRoster,
                onClick: () => {
                    this.selectSubroster(R.SubRoster);
                },
                children: [String(R.SubRoster), R.Name].map(txt => ({
                    tag: 'span',
                    key: txt,
                    title: txt,
                    text: txt,
                })),
            })),
        };
    }
    changeSort(key) {
        this.setState(s => ({
            sortKey: key,
            sortReverse: key === s.sortKey && !s.sortReverse,
        }));
    }
    getFacilities() {
        return fsmData(this.state.facilities ?? [], {
            filter: F => {
                if (this.state.search !== '') {
                    const txt = F.Name.toLowerCase();
                    const bool_a = txt.indexOf(this.state.search) !== -1;
                    const bool_b = String(F.ID).indexOf(this.state.search) !== -1;
                    return bool_a || bool_b;
                }
                return true;
            },
            reverse: this.state.sortReverse,
            sort: F => {
                switch (this.state.sortKey) {
                    case 1:
                        return F.ID;
                    case 2:
                        return F.Name;
                    default:
                        const prefix = F.Enabled ? '' : 'zzzz ';
                        return `${prefix}${F.Name}`;
                }
            },
        });
    }
    getSubrosters() {
        return fsmData(this.state.rosters ?? [], {
            filter: R => {
                if (this.state.selectedFacility !== R.Facility) {
                    return false;
                }
                else if (this.state.search !== '') {
                    const txt = R.Name.toLowerCase();
                    const bool_a = txt.indexOf(this.state.search) !== -1;
                    const bool_b = String(R.SubRoster).indexOf(this.state.search) !== -1;
                    return bool_a || bool_b;
                }
                return true;
            },
            reverse: this.state.sortReverse,
            sort: R => {
                switch (this.state.sortKey) {
                    case 1:
                        return R.SubRoster;
                    case 2:
                        return R.Name;
                    default:
                        return R.Name;
                }
            },
        });
    }
    buildSearchBox() {
        return {
            tag: 'input',
            key: 'txtSearch',
            cl: 'tb2 txtSearch',
            placeholder: 'Filter...',
            autoFocus: window.size !== 'mobile',
            value: this.state.search,
            onBlur: (e) => {
                e.target.focus();
            },
            onChange: (e) => {
                const v = e.target.value?.toLowerCase() ?? '';
                this.setState({ search: v }, () => {
                    this.updateHighlightedFromSearch();
                });
            },
            onKeyDown: (e) => {
                e.stopPropagation();
                switch (e.keyCode) {
                    case 38:
                        this.moveSelection(-1);
                        break;
                    case 40:
                        this.moveSelection(+1);
                        break;
                    case 13:
                        this.pressEnter();
                        break;
                    default:
                        return;
                }
                e.preventDefault();
            },
        };
    }
    moveSelection(dir) {
        let index, list;
        if (!this.state.selectedFacility) {
            list = this.getFacilities().map(F => F.ID);
            index =
                this.state.highlightedFacility != null
                    ? list.indexOf(this.state.highlightedFacility)
                    : -1;
        }
        else {
            list = this.getSubrosters().map(F => F.SubRoster);
            index =
                this.state.highlightedSubroster != null
                    ? list.indexOf(this.state.highlightedSubroster)
                    : -1;
        }
        index += dir;
        if (index < 0) {
            index = 0;
        }
        if (index >= list.length) {
            index = list.length - 1;
        }
        if (this.state.selectedFacility == null) {
            this.setState({ highlightedFacility: list[index] });
        }
        else {
            this.setState({ highlightedSubroster: list[index] });
        }
    }
    pressEnter() {
        if (this.state.selectedFacility == null) {
            this.selectFacility(this.state.highlightedFacility ?? undefined);
        }
        else {
            this.selectSubroster(this.state.highlightedSubroster ?? undefined);
        }
    }
    updateHighlightedFromSearch() {
        if (this.state.selectedFacility == null) {
            const facilities = new Set(this.getFacilities().map(F => F.ID));
            if (this.state.highlightedFacility != null &&
                !facilities.has(this.state.highlightedFacility)) {
                this.setState({ highlightedFacility: null });
            }
        }
        else {
            const subrosters = new Set(this.getSubrosters().map(F => F.SubRoster));
            if (this.state.highlightedSubroster != null &&
                !subrosters.has(this.state.highlightedSubroster)) {
                this.setState({ highlightedSubroster: null });
            }
        }
    }
    selectFacility(key) {
        key = key ?? this.getFacilities()[0]?.ID;
        this.setState({
            selectedFacility: key,
            highlightedFacility: null,
            highlightedSubroster: this.state.highlightedSubroster ?? 0,
            search: '',
        }, () => {
            if (this.getSubrosters().length <= 1) {
                this.selectSubroster();
            }
        });
    }
    selectSubroster(key) {
        key = key ?? this.getSubrosters()[0]?.SubRoster ?? undefined;
        this.setState({
            selectedSubroster: key,
            highlightedSubroster: null,
            search: '',
        }, () => {
            this.finished();
        });
    }
    finished() {
        this.props.flyout.Close();
        const k = null;
        trionlineAjax({
            url: '/api/switch/',
            data: {
                d: JSON.stringify([
                    this.state.selectedFacility,
                    this.state.selectedSubroster,
                    k,
                ]),
            },
            no: () => {
                location.reload();
            },
            yes: () => {
                localStorage['currentRoster'] = null;
                location.reload();
            },
        });
    }
}
//# sourceMappingURL=component-facility-switcher.js.map